export function getDefaultCardWidth(navbar) {
  return `w-[calc(100vw-25px)] ${navbar ? 'desktop:w-[calc(100vw-238px)]' : 'desktop:w-[calc(100vw-33px)]'}`;
}